export const BUDGET_MANAGER_TEXTS = {
    CLUSTER_EDITED_SUCCESSFULLY: 'Cluster edited successfully',
    CLUSTERS_SAVED_SUCCESSFULLY: 'Clusters saved successfully',
    CLUSTERS_FAILED_TO_SAVE: 'An error occurred while trying to save the Clusters. Please, contact support',
    CLUSTER_ALREADY_EXISTS: 'Cluster already exists',
};

export const BUDGET_MANAGER_SORT_STATUS = {
    enabled: -1,
    active: -1,
    paused: 0,
    removed: 1,
    campaign_paused: 0,
    ended: 1,
};
